module.exports = __webpack_public_path__ + "media/images/icons/icon-facebook-4f4ba4b3918b15d0ee48a8102b41bda8.svg";